import React from 'react';
import HelpDeskTicketList from './HelpDeskTicketList';

export default function HelpDeskMyTickets() {
  return <HelpDeskTicketList title="My tickets" scope="my" />;
}
